<template>
  <!-- <el-scrollbar> -->
    <router-view />
  <!-- </el-scrollbar> -->

</template>

<script setup>

import { onMounted, reactive, defineExpose } from 'vue';
import { requestNoToken } from '@/util/adminRequest.js'
import store from '@/configure/store'

//获取版权信息
const getSystemMetaCopyrightShow =  ()=> {
  requestNoToken({
    url: '/Api/baseSystem/AdminModule/SystemMeta/GetSystemMetaCopyrightShow',
    data: {}
  }).then(res => {
    store.commit('saveSystemMetaCopyrightData',
      {
        systemCopyrightName: res.data.systemCopyrightName,
        systemCopyrightWebsite: res.data.systemCopyrightWebsite,
        systemCopyrightDay: res.data.systemCopyrightDay,
        systemCopyrightICP: res.data.systemCopyrightICP,
        systemCopyrightSecurity: res.data.systemCopyrightSecurity,
        systemCopyrightState: res.data.systemCopyrightState
      }
    )
  })
}

//获取基础信息
const getSystemMetaBaseShow = function () {
  requestNoToken({
    url: '/Api/baseSystem/AdminModule/SystemMeta/GetSystemMetaTenantShow',
    data: {}
  }).then(res => {
     store.commit('saveSystemMetaBaseData',
      {
        systemName: res.data.systemTenantName,
        systemMiniName: res.data.systemTenantMiniName,
        // systemDescribe: res.data.systemDescribe,
        systemLogo: res.data.systemTenantLogoFile,
        systemLoginBackgroundFile: res.data.systemTenantLoginBackgroundFile,
        systemMainBackgroundFile: res.data.systemMainBackgroundFile
      }
    )
  })
  // getSystemLogo()
}

// // 获取系统logo
// const getSystemLogo = function () {
//   requestNoToken({
//     url: '/Api/baseSystem/AdminModule/SystemMeta/GetSystemMetaBaseShow',
//     data: {}
//   }).then(res => {
//     store.commit('saveSystemLogo',
//       {
//         systemLogo: res.data.systemLogo,
//       }
//     )
//   })
// }

// 启动调用
onMounted(() => {
  getSystemMetaBaseShow()
  getSystemMetaCopyrightShow()
})
</script>
